module.exports = __webpack_public_path__ + "./assets/img_osakaShinsaibashi_grey@2x__aaade82b3acf7585b445ebdffe8e04e4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/home/thumbnail/img_osakaShinsaibashi_grey@2x.jpg
// module id = 646
// module chunks = 12